import { Injectable, SecurityContext } from '@angular/core';
import { EmailAccountSignatureType } from './email-account-signature-type.enum';
import { EmailAccountsService } from './email-accounts.service';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class EmailSignatureInjectorService {

  constructor(private _emailAccountsService: EmailAccountsService, private _sanitizer: DomSanitizer) { }

  public addSignatureOfEmailAccount(emailAccountId): Promise<string> {
    return this._emailAccountsService.getEmailAccountSignature(emailAccountId)
      .then((signature) => {
        let resultMessage;

        if (signature.type === EmailAccountSignatureType.Always && signature.contentAsHtml) {
          const sanitizedSignature = this._sanitizer.sanitize(SecurityContext.HTML, signature.contentAsHtml);
          resultMessage = `\u2013\u2013 ${sanitizedSignature}`;
        } else {
          resultMessage = '';
        }

        return resultMessage;
      });
  }
}
